import { Col, Row } from "antd";
import { OurStrengthPc } from './ourstrength'
import { OurStrengthPhBox } from './ourstrengthph'

export function OurStrengthBox(props) {
  return (
    <Row>
      <Col xs={0} sm={0} md={0} lg={24} xl={24}>
        <div className="our-strength-pc">
          <OurStrengthPc />
        </div>
      </Col>
      <Col xs={24} sm={24} md={24} lg={0} xl={0}>
        <OurStrengthPhBox />
      </Col>
    </Row>
  )
}